import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { isTabletOrMobileDevice } from 'constants/app';
import { getIsMarketGraphsDarkThemeEnabled } from 'redux/modules/appConfigs/selectors';

import MarketGraphClosePageBtn from '../MarketGraphMobileClosePageBtn/MarketGraphClosePageBtn';
import MarketGraphNoData from '../MarketGraphNoData/MarketGraphNoData';

import styles from './MarketGraphBlacklistedMarket.module.scss';

export default function MarketGraphBlacklistedMarket() {
  const isDarkTheme = useSelector(getIsMarketGraphsDarkThemeEnabled);

  return (
    <div
      className={classNames(styles.container, {
        [styles.container__mobile]: isTabletOrMobileDevice,
        [styles.container__dark]: isDarkTheme
      })}
    >
      <div
        className={classNames(styles.content, {
          [styles.content__mobile]: isTabletOrMobileDevice,
          [styles.content__dark]: isDarkTheme
        })}
      >
        {isTabletOrMobileDevice && (
          <div className={styles.header}>
            <MarketGraphClosePageBtn iconClassName={isDarkTheme ? undefined : styles.closeIcon} />
          </div>
        )}
        <MarketGraphNoData type="blacklisting" />
      </div>
    </div>
  );
}
